// Convert to a regular function that can be called inside useEffect
const processApiOptions = (apiResponse, setStateFunction, savedValues = []) => {
  if (!apiResponse) return;

  setStateFunction(
    Object.entries(apiResponse).map(([key, resValue]) => {
      let prefixIcon;

      switch (key) {
        // Assets
        case 'DATABASE':
        case 'SERVER':
        case 'VAULT':
          prefixIcon = {
            isApplicationIcon: false,
            kind: key.toLowerCase(),
          };
          break;
        case 'APPLICATION':
          prefixIcon = {
            isApplicationIcon: false,
            kind: 'Applications',
          };
          break;
        // Platforms
        case 'ON_PREMISE':
          prefixIcon = {
            isApplicationIcon: true,
            kind: 'Placeholder',
            size: 'xSmall',
          };
          break;
        // Roles
        case 'EMERGENCYACCESSROLE':
          prefixIcon = {
            isApplicationIcon: false,
            kind: 'Role',
            size: 'medium',
          };
          break;
        default:
          prefixIcon = {
            isApplicationIcon: true,
            kind: key,
            size: 'xSmall',
          };
          break;
      }

      return {
        label: resValue,
        value: key,
        isChecked: savedValues.includes(key),
        prefixIcon,
      };
    })
  );
};

export { processApiOptions };
